interface AssetsPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function AssetsPagination({
  currentPage,
  totalPages,
  onPageChange,
}: AssetsPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center gap-2 mt-8">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="px-4 py-2 rounded-lg bg-white/[0.05] text-white disabled:opacity-50 hover:bg-white/[0.1] transition-colors"
      >
        Previous
      </button>
      <span className="px-4 py-2 text-[#888]">
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="px-4 py-2 rounded-lg bg-white/[0.05] text-white disabled:opacity-50 hover:bg-white/[0.1] transition-colors"
      >
        Next
      </button>
    </div>
  );
}
